import app from 'firebase/app';
import { convertDateToFirestoreTimestamp, executeSearchQuery } from './firestoreUtils';

const getReviewCollection = () => app.firestore().collection('reviews');

export const getReviewByUid = uid => {
    let docRef = getReviewCollection().doc(uid);
    return docRef
        .get()
        .then(function (doc) {
            if (doc.exists) {
                return doc.data();
            } else {
                console.log('No such document!');
            }
        })
        .catch(function (error) {
            console.log('Error getting document:', error);
        });
};

export const createReview = dto => {
    return getReviewCollection().add({
        ...dto,
        createdTimestamp: convertDateToFirestoreTimestamp(new Date()),
    });
};

export const updateReview = dto => {
    return new Promise(function (resolve, reject) {
        const docRef = getReviewCollection().doc(dto.uid);
        docRef.update({ ...dto });
        if (docRef && docRef.id) {
            resolve(docRef.id);
        } else {
            reject('Object not created');
        }
    });
};

export const getReviewCheck = (userUid, postUid) => {
    return getReviewCollection()
        .where('publisherUid', '==', userUid)
        .where('postUid', '==', postUid)
        .get();
};

export const getReviewsByPostUId = (pageSize, postUid, lastElement) => {
    const query = buildSearchQuery(postUid, 'createdTimestamp', pageSize, lastElement);
    return executeSearchQuery(query);
};

export const getReviewsAfterDate = (postOwnerUid, afterTimestamp) => {
    const query = getReviewCollection()
        .where('postOwnerUid', '==', postOwnerUid)
        .where('createdTimestamp', '>', afterTimestamp);
    return executeSearchQuery(query);
};

export const getReviewersEmails = postId => {
    return getReviewCollection()
        .where('postUid', '==', postId)
        .get()
        .then(snap =>
            Promise.all(
                snap.docs.map(d => {
                    const { publisherUid } = d.data();
                    return app.firestore().collection('users').doc(publisherUid).get();
                })
            )
        )
        .then(snaps => snaps.map(d => d.data().email));
};

const buildSearchQuery = (postUid, orderBy, pageSize, lastElement) => {
    let query = getReviewCollection();
    if (orderBy) {
        query = query.orderBy(orderBy);
    }
    if (postUid) {
        query = query.where('postUid', '==', postUid);
    }
    if (pageSize) {
        query = query.limit(pageSize);
    }
    if (lastElement) {
        query = query.startAfter(lastElement);
    }
    return query;
};
